import { Strengths, StrengthsJSON } from '../types/CompanyStrengthsTypes';

export default class StrengthsSerializer {
  
  static toObject(payload: StrengthsJSON): Strengths {
    return {
      topThree: payload.strengths.top_three,
      all: payload.strengths.all.map(strength => ({
        resourceId: strength.resource_id,
        label: strength.label,
        distribution: strength.distribution,
        percentage: strength.percentage
      }))
    };
  }
}

